import moment, { Moment } from 'moment';
import useQuestionnaireResultTable from '../../../../Questionnaire/Hooks/useQuestionnaireResultTable';
import useNotification from '../../../../../Hooks/useNotification.hook';
import labResultsForm from '../CreatePlanSections/LabResultsForm';

const questionnairesSetup = [
	{
		questionnaireCode: 'meddibaby_regular_inspection',
		weightKey: 'mothersHealth.actualWeight',
	},
	{
		questionnaireCode: 'meddibaby_entry_questionnaire',
		weightKey: 'mothersHealth.actualWeight',
	},
	{
		questionnaireCode: 'meddi_baby_czech_patient',
		weightKey: 'mothersActualWeight',
	},
];

export default function useMothersLastWeight() {
	const { getData } = useQuestionnaireResultTable();

	const getWeightData = async (patientId: string) => {
		const weightData: { data: string; value: string; date: Moment }[] = [];
		try {
			await Promise.all(
				questionnairesSetup.map(async ({ questionnaireCode, weightKey }) => {
					const data = await getData(patientId, questionnaireCode);
					const weight = data?.data.find((item: any) => item.key === weightKey);
					if (weight) {
						return weight.values.map((val: any) => {
							val['date'] = moment(val.data);
							weightData.push(val);
						});
					} else {
						return;
					}
				}),
			);
		} catch (e: any) {
			console.log('error', e);
		}
		return weightData;
	};

	const getMothersLastWeight = async (patientId: string) => {
		const weightData = await getWeightData(patientId);
		if (weightData.length) {
			const lastWeight = parseFloat(
				weightData.sort((a, b) => b.date.valueOf() - a.date.valueOf())[0].value,
			);
			return lastWeight;
		}
	};

	return {
		getMothersLastWeight,
	};
}
